import { useIntl } from "react-intl";
import CustomSelect from "../CustomSelect";
import { Genders } from "~enums/genders";

type Props = {
  className?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  value?: string;
}

const SelectPersonGender = ({ className, disabled, onChange, value }: Props) => {
  const { formatMessage } = useIntl();

  const options = [
    { value: Genders.Female, label: formatMessage({ id: `gender.${Genders.Female}` })},
    { value: Genders.Male, label: formatMessage({ id: `gender.${Genders.Male}` })},
    { value: Genders.Unknown, label: formatMessage({ id: `gender.${Genders.Unknown}` })},
  ];

  return (
    <CustomSelect
      value={value}
      onChange={(value) => onChange?.(value as string)}
      options={options}
      placeholder={formatMessage({id: "gender"})}
      allowClear
      className={className}
      disabled={disabled}
    />
  );
}

export default SelectPersonGender;
